import { render, staticRenderFns } from "./BaseInputDropdown.vue?vue&type=template&id=b58439a8&"
import script from "./BaseInputDropdown.vue?vue&type=script&lang=js&"
export * from "./BaseInputDropdown.vue?vue&type=script&lang=js&"
import style0 from "./BaseInputDropdown.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports